module.exports = __webpack_public_path__ + "img/none.5e8e5fd3.png";